import { uploadBlob } from "../api/connection";

export async function transferToBlob(sourceUrl: string, containerName: string, blobName: string) {
  const headers = new Headers();
  headers.append("Accept", "application/octet-stream");

  const response = await fetch(sourceUrl, { headers });

  const data = await response.arrayBuffer();

  await uploadBlob(containerName, blobName, data);
}

export interface BlobItem {
  name: string;
  url: string;
  lastModified?: string;
  contentLength?: number;
}

export interface ListBlobsResult {
  blobs: BlobItem[];
  prefixes: string[]; // Virtual directories
}
// https://techmageus.blob.core.usgovcloudapi.net/downloads/hmi_apk/hmi_1.0.5.apk
// https://techmageus.blob.core.usgovcloudapi.net/downloads/hmi_1.0.5.apk
export async function listPublicBlobs(
  prefix: string = ''
): Promise<ListBlobsResult> {
  const baseUrl = `https://techmageus.blob.core.usgovcloudapi.net/downloads`;
  const queryParams = new URLSearchParams({
    restype: 'container',
    comp: 'list',
  });

  if (prefix) {
    queryParams.append('prefix', prefix);
  }

  const url = `${baseUrl}?${queryParams.toString()}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status} ${response.statusText}`);
    }

    const text = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(text, 'application/xml');

    // Parse blobs
    const blobs: BlobItem[] = Array.from(xmlDoc.querySelectorAll('Blob')).map((blobNode) => {
      const name = blobNode.querySelector('Name')?.textContent || '';
      return {
        name,
        url: `${baseUrl}/${encodeURIComponent(name)}`,
        lastModified: blobNode.querySelector('Last-Modified')?.textContent || undefined,
        contentLength: Number(blobNode.querySelector('Content-Length')?.textContent) || undefined,
      };
    });

    // Parse virtual directories (BlobPrefix)
    const prefixes: string[] = Array.from(xmlDoc.querySelectorAll('BlobPrefix')).map(
      (prefixNode) => prefixNode.querySelector('Name')?.textContent || ''
    );

    return { blobs, prefixes };
  } catch (error) {
    console.error('Failed to list blobs:', error);
    return { blobs: [], prefixes: [] };
  }
}